import React from 'react';
import PropTypes from 'prop-types';
import { getDisplayName } from 'shared/helpers/common';
import queryString from 'query-string';
import history from '../../history';

const MAX_PAGE_COUNT = 500;

const withPaginate = WrappedComponent =>
  class extends React.Component {
    static displayName = `withPaginate(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      query: PropTypes.shape(),
      url: PropTypes.string,
      pageCount: PropTypes.number,
      anchor: PropTypes.string,
    };
    static defaultProps = {
      pageCount: 1,
      url: null,
      query: null,
      anchor: '',
    };

    pageChanger = ({ selected }) => {
      const { search, pathname } = history.location;
      const { anchor } = this.props;
      const query = queryString.parse(search);
      const searchInfo = queryString.stringify({
        ...query,
        ...{ page: selected ? selected + 1 : undefined },
      });

      history.push(`${pathname}${searchInfo ? `?${searchInfo}` : ''}${anchor}`);
    };

    hrefBuilder = pageIndex => {
      const { url } = this.props;
      const searchInfo = queryString.stringify({
        ...(pageIndex && pageIndex > 1 ? { page: pageIndex || undefined } : {}),
      });

      return `${url || ''}${searchInfo ? `?${searchInfo}` : ''}`;
    };

    render() {
      const { pageCount, url, query, ...props } = this.props;
      const transformedPageCount = Math.min(parseInt(pageCount, 10), MAX_PAGE_COUNT);

      const key = `${url || ''}-${JSON.stringify(query || {})}`;

      return (
        <WrappedComponent
          key={key}
          hrefBuilder={this.hrefBuilder}
          pageChanger={this.pageChanger}
          pageCount={transformedPageCount}
          url={url}
          query={query}
          {...props}
        />
      );
    }
  };

export default withPaginate;



// WEBPACK FOOTER //
// ./src/shared/hocs/withPaginate.js